import {
  createParentBridge as createIframefParentBridge,
  createChildBridge as createIframeChildBridge,
} from './iframe/channel';
import {
  createParentBridge as createWorkerParentBridge,
  createChildMainBridge,
  createChildWorkerBridge,
} from './worker/channel';
import { IChannel } from './ChannelMessage';
import { isInWorker, isInServer } from '../InteractComps/utils';

export {
  ChannelNameSpace,
  ChannelMessage,
  IParentBridge,
  IChannel,
  CompsNameSpace,
} from './ChannelMessage';

export { CompsBridge } from './CompsBridge';

export const createParentBridge = (param: IChannel) => {
  if (param.useWorker) {
    return createWorkerParentBridge(param);
  }
  return createIframefParentBridge(param);
};

export const createChildBridge = () => {
  // worker运行环境中子通道里面的main通道
  if (isInWorker || isInServer) {
    return createChildWorkerBridge();
  }
  // worker运行环境中子通道里面的worker通道
  if (!!window.interactWorker) {
    return createChildMainBridge();
  }
  return createIframeChildBridge();
};
